import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { TrainerMe } from '../api/types';
import { Theme } from '../theme';
import ThemeToggle from './ThemeToggle';

const ITEMS = [
  { to: '/', label: 'Dashboard' },
  { to: '/activities', label: 'Activities' },
  { to: '/health', label: 'Health' },
  { to: '/fitness', label: 'Fitness' },
  { to: '/records', label: 'Records' },
  { to: '/settings', label: 'Settings' },
];

const AppNav: React.FC<{ user: TrainerMe; theme: Theme; onToggleTheme: () => void }> = ({ user, theme, onToggleTheme }) => (
  <Navbar expand="md" className="app-nav" sticky="top" collapseOnSelect>
    <Container fluid="lg">
      <Navbar.Brand as={NavLink} to="/" className="d-flex align-items-center">
        <span className="navbar-brand-mark" aria-hidden="true">T</span>
        Trainer
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="trainer-nav" />
      <Navbar.Collapse id="trainer-nav">
        <Nav className="me-auto" as="nav" aria-label="Main navigation">
          {ITEMS.map(item => (
            <Nav.Link key={item.to} as={NavLink} to={item.to} end={item.to === '/'}>
              {item.label}
            </Nav.Link>
          ))}
        </Nav>
        <div className="d-flex align-items-center gap-2 py-2 py-md-0">
          <span className="muted small text-truncate" style={{ maxWidth: 180 }} title={user.email}>
            {user.name ?? user.email}
          </span>
          <ThemeToggle theme={theme} onToggle={onToggleTheme} />
        </div>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);

export default AppNav;
